module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_inscription_remoteEntry_mjs_0c881df4__;